import axios from "axios";
import { AnimatePresence, motion } from "framer-motion";
import { Check, Clock } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "src/components/ui/button";
import QuestionCard from "../../../../components/Quiz/question-card";
import { BaseUrlApi, ErrorMessage } from "../../../../lib/api";
import { QuizData } from "../../../../lib/languages";
import { useLanguage } from "../../../../context/LanguageContext";
import { useBlockAllCopy } from "../../../../lib/utils";

export default function SurveyTaker({ questions, survey }) {
  const { language } = useLanguage();
  const t = QuizData[language] || QuizData.en;
  const navigate = useNavigate();
  console.log(questions);
  // State management
  const [navigateIdx, setNavigateIdx] = useState(0);
  const [submitted, setSubmitted] = useState(false);
  const [selectAnswers, setSelectAnswers] = useState({});
  const [allAnswers, setAllAnswers] = useState([]);

  // Handle answer changes for both single and multiple selections
  const handleAnswerChange = (questionId, selectedOptions) => {
    // Ensure selectedOptions is always an array
    const optionIds = Array.isArray(selectedOptions)
      ? selectedOptions
      : [selectedOptions];

    // Update selectAnswers for UI rendering
    setSelectAnswers((prev) => ({ ...prev, [questionId]: optionIds }));

    // Update allAnswers to group options under question_id
    setAllAnswers((prev) => {
      const filtered = prev.filter((a) => a.question_id !== questionId);
      return [
        ...filtered,
        {
          question_id: questionId,
          option_ids: optionIds,
        },
      ];
    });
  };

  // Submit survey responses
  const submitSurvey = async () => {
    try {
      // Format payload to match requested structure
      const payload = {
        answers: allAnswers.map(({ question_id, option_ids }) => ({
          question_id,
          option_ids,
        })),
      };
      await axios.post(
        `${BaseUrlApi}/user/surveys/${survey?.id}/submit`,
        payload
      );
      setSubmitted(true);
      //   navigate(-1, { replace: true });
    } catch (error) {
      toast("Error", { description: ErrorMessage(error) });
    }
  };

  // Check if all questions have at least one answer
  const allQuestionsAnswered = questions?.every((q) =>
    allAnswers.some((a) => a.question_id === q.id && a.option_ids.length > 0)
  );

  //   useBlockAllCopy();

  return (
    <div className="space-y-6 nocopy" dir={language === "ar" ? "rtl" : "ltr"}>
      {/* Survey Title */}
      {/* <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold">{t.surveyTitle || "Survey"}</h1>
      </div> */}

      {/* Render Current Question */}
      {questions?.length > 0 &&
        questions.map((question, index) => (
          <QuestionCard
            key={index}
            question={question}
            removeQuestion={() => {}}
            isEditMode={false}
            isShowMode={submitted}
            selectedAnswer={selectAnswers[question.id] || []}
            onAnswerSelect={(selectedOptions) =>
              handleAnswerChange(question.id, selectedOptions)
            }
            showCorrectAnswers={true}
            isSurvey={true}
          />
        ))}

      {/* Navigation and Submission */}
      <div className="flex items-center justify-between mt-8">
        {/* <Button
          onClick={() => setNavigateIdx((idx) => idx - 1)}
          variant="outline"
          className="w-32"
          disabled={navigateIdx === 0}
        >
          {t.previous}
        </Button> */}
        {/* <span>
          {navigateIdx + 1} / {questions.length}
        </span> */}
        <Button
          onClick={submitSurvey}
          className="w-32 bg-blue-600 hover:bg-blue-700"
          disabled={!allQuestionsAnswered || submitted}
        >
          {t.submitSurvey || "Submit Survey"}
        </Button>
      </div>

      {/* Submission Confirmation */}
      {submitted && (
        <div className="p-4 bg-green-500/20 border border-green-200 rounded-md text-center">
          <h3 className="text-lg font-medium">شكرًا لمشاركتك!</h3>
          <p className="text-green-600 flex items-center justify-center">
            <Check className="h-5 w-5 mr-2" />
            تم إرسال الاستبيان بنجاح. نُقدّر وقتك ومساهمتك القيّمة.
          </p>
        </div>
      )}
    </div>
  );
}
